
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
export const routes = [
  {
    path: "/pc",
    component: () => import("@/components/HelloWorld.vue")
  },
  {
    path: "/mobile",
    component: () => import("@/components/index.vue")
  },
  {
    path: "/service",
    component: () => import("@/components/serviceIfname.vue")
  },



]

const router = new Router({
  routes
})



export default router
